export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=40b80a6b223f14499508cfc6946be8a08a6f26747f&name=revalidateCommunity!'